var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "random-question-container" },
    [
      _c("div", { staticClass: "title flex-row align-center" }, [
        _c("span", [_vm._v("随机抽题")]),
        _c(
          "div",
          {
            staticClass: "flex-row align-center ml-10",
            staticStyle: { "font-size": "14px" },
            on: {
              click: function ($event) {
                return _vm.openRuleDialog()
              },
            },
          },
          [
            _c(
              "el-button",
              { attrs: { type: "text", icon: "el-icon-circle-plus-outline" } },
              [_vm._v("添加规则")]
            ),
            _c("div", { staticClass: "border_l" }),
            _c(
              "span",
              { staticClass: "setting", attrs: { title: "随机抽题" } },
              [
                _c("i", { staticClass: "el-icon-setting" }),
                _vm.isSetting
                  ? _c("span", { staticClass: "drawing-item__check" }, [
                      _c("i", { staticClass: "el-icon-check" }),
                    ])
                  : _vm._e(),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-alert",
        {
          staticClass: "info-alert",
          attrs: { type: "warning", closable: false, "show-icon": false },
        },
        [
          _c("p", [
            _vm._v("1. 设置题目抽取范围内后，系统自动抽取部分题目在用户侧展示"),
          ]),
          _c("p", [_vm._v("2. 不支持跨题目组建立抽题")]),
          _c("p", [
            _vm._v(
              "3. 如果题目组中包含了题目关联逻辑，设置随机抽题后可能会导致部分逻辑失效，请仔细检查！"
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "setting-random-logic",
          attrs: {
            title: "设置抽题规则",
            visible: _vm.rulesVisible,
            width: "65%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rulesVisible = $event
            },
            close: _vm.resetForm,
          },
        },
        [
          _c(
            "el-form",
            {
              staticClass: "question-form",
              attrs: { "label-width": "70px", "label-position": "left" },
            },
            [
              _vm._l(_vm.rules, function (ruleItem, index) {
                return _c(
                  "el-row",
                  { key: index, attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "从题目" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择",
                                  filterable: "",
                                  clearable: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.getRandomCount(ruleItem)
                                  },
                                },
                                model: {
                                  value: ruleItem.beginFormItemId,
                                  callback: function ($$v) {
                                    _vm.$set(ruleItem, "beginFormItemId", $$v)
                                  },
                                  expression: "ruleItem.beginFormItemId",
                                },
                              },
                              _vm._l(
                                _vm.currenGroupItem.items,
                                function (questionItem) {
                                  return _c("el-option", {
                                    key: questionItem.formItemId,
                                    attrs: {
                                      disabled: _vm.isDisabledBegin(
                                        ruleItem,
                                        questionItem
                                      ),
                                      label:
                                        _vm.computedLabels[
                                          questionItem.formItemId
                                        ],
                                      value: questionItem.formItemId,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "到题目" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择",
                                  filterable: "",
                                  clearable: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.getRandomCount(ruleItem)
                                  },
                                },
                                model: {
                                  value: ruleItem.endFormItemId,
                                  callback: function ($$v) {
                                    _vm.$set(ruleItem, "endFormItemId", $$v)
                                  },
                                  expression: "ruleItem.endFormItemId",
                                },
                              },
                              _vm._l(
                                _vm.currenGroupItem.items,
                                function (questionItem) {
                                  return _c("el-option", {
                                    key: questionItem.formItemId,
                                    attrs: {
                                      disabled: _vm.isDisabledEnd(
                                        ruleItem,
                                        questionItem
                                      ),
                                      label:
                                        _vm.computedLabels[
                                          questionItem.formItemId
                                        ],
                                      value: questionItem.formItemId,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "随机抽取" } },
                          [
                            _c("el-input", {
                              staticClass: "small-input",
                              on: {
                                input: function ($event) {
                                  return _vm.validateInput(ruleItem)
                                },
                              },
                              model: {
                                value: ruleItem.num,
                                callback: function ($$v) {
                                  _vm.$set(ruleItem, "num", $$v)
                                },
                                expression: "ruleItem.num",
                              },
                            }),
                            _c("span", [_vm._v("道题目")]),
                            _c("el-button", {
                              staticClass: "add-btn",
                              attrs: {
                                type: "text",
                                icon: "el-icon-circle-plus-outline",
                              },
                              on: { click: _vm.addRule },
                            }),
                            _c("el-button", {
                              staticClass: "remove-btn",
                              attrs: {
                                type: "text",
                                icon: "el-icon-remove-outline",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeRule(index)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm.rules.length === 0
                ? _c("el-empty", { attrs: { description: "" } }, [
                    _c(
                      "div",
                      [
                        _vm._v("暂无数据，"),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: { click: _vm.addRule },
                          },
                          [_vm._v("点击添加")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 提示：设置抽题范围时请勿设置重复区间，否则题目重复时实际抽题数量与设置数量可能会不一致，请仔细检查！ "
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rulesVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmAddRules },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }